const styles = {
  typographyRadio: {
    borderRadius: "5px",
    background: "#F5F5F5",
    color: "#616161",
    padding: "0.3rem 1rem",
    fontSize: 14,
    fontWeight: 500,
    cursor: "pointer",
  },
};

export default styles;
